import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { AuthContext } from "../context/authContext";

const EditLinks = () => {
  const { currentUser } = useContext(AuthContext);
  const [links, setLinks] = useState([]);
  const [title, setTitle] = useState("");
  const [url, setUrl] = useState("");

  const fetchLinks = async () => {
    try {
      const res = await axios.get("/api/links");
      setLinks(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchLinks();
  }, []);

  const handleAdd = async (e) => {
    e.preventDefault();
    if (!title.trim() || !url.trim()) return;
    try {
      await axios.post("/api/links", { title, url });
      setTitle("");
      setUrl("");
      fetchLinks();
    } catch (err) {
      console.log(err);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`/api/links/${id}`);
      fetchLinks();
    } catch (err) {
      console.log(err);
    }
  };

  if (currentUser?.username !== "emma20106") {
    return (
      <div className="add-picture">
        <h2>Sorry, only the blog owner can manage links!</h2>
      </div>
    );
  }

  return (
    <div className="add-picture">
      <h1>Manage Links</h1>
      <form onSubmit={handleAdd}>
        <input
          type="text"
          placeholder="Link text (e.g. 'this article I love')"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <input
          type="text"
          placeholder="URL (e.g. https://example.com)"
          value={url}
          onChange={(e) => setUrl(e.target.value)}
        />
        <button type="submit">Add Link</button>
      </form>

      <div className="links-manager-list">
        {links.map((link) => (
          <div className="links-manager-item" key={link.id}>
            <span>{link.title}</span>
            <button onClick={() => handleDelete(link.id)}>delete</button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default EditLinks;
